import { FormattedMessage } from 'react-intl'
import { useAppDispatch } from 'universal-scripts'
import { openItemEditor } from 'src/store/slices/dashboard'
import type { ResourceScope } from 'src/types/global'
import { useQueryListData } from '@hooks/useQueryListData'

interface WidgetCatalogListProps {
  scope: ResourceScope
}

export default function WidgetCatalogList({ scope }: WidgetCatalogListProps) {
  const dispatch = useAppDispatch()
  const items = useQueryListData(scope)
  const noItems = items?.length === 0

  if (noItems)
    return (
      <p>
        <FormattedMessage id="empty-state.empty.query.title" />
      </p>
    )

  const handleAdd = (queryId: string) => {
    const query = items.find((q) => q.id === queryId)
    if (!query) return
    dispatch(
      openItemEditor({
        type: 'chart',
        itemId: null,
        queryId: query.id,
        defaultTitle: query.title,
        defaultDescription: query.description ?? ''
      })
    )
  }

  return (
    <ul className="widget-catalog-list">
      {items.map((query) => (
        <li
          key={query.id}
          className="widget-catalog-item widget-catalog-item-query"
        >
          <section title={query.title}>
            <span className="icon icon-query" />
            <span className="ellipsis">{query.title}</span>
          </section>
          <button onClick={() => handleAdd(query.id)}>
            <FormattedMessage id="add" />
          </button>
        </li>
      ))}
    </ul>
  )
}
